import axios from 'axios';
import API_BASE_URL from '../../../../config/apiConfig';

const API_URL = `${API_BASE_URL}/api/IACarePlan/generate`;

export const generateIACarePlan = async (patientData) => {
  try {
    const response = await axios.post(API_URL, patientData, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem("token")}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data; // { resultado: "..." }
  } catch (error) {
    console.error("Error al generar el plan de atención con IA:", error.response?.data || error.message);
    throw error;
  }
};